import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import axios from "axios";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  responsive: true,
  plugins: {
    legend: { position: "top" },
  },
};

export default function FeesChart({ programmeName, level, semester }) {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    const fetchFeeData = async () => {
      try {
        const res = await axios.get("http://localhost:3003/api/fees", {
          params: { programmeName, level, semester },
        });

        const feeAmount = res.data.feeAmount;
        const paidAmount = res.data.paidAmount ?? 0; // Fallback if not returned
        const outstandingAmount = feeAmount - paidAmount;

        const data = {
          labels: ["Current Session"],
          datasets: [
            {
              label: "Paid",
              data: [paidAmount],
              backgroundColor: "rgba(75, 192, 192, 0.6)",
            },
            {
              label: "Outstanding",
              data: [outstandingAmount],
              backgroundColor: "rgba(255, 99, 132, 0.6)",
            },
          ],
        };

        setChartData(data);
      } catch (err) {
        console.error("Error fetching fee data:", err);
      }
    };

    if (programmeName && level && semester) {
      fetchFeeData();
    }
  }, [programmeName, level, semester]);

  if (!chartData) return <p>Loading fee chart...</p>;

  return <Bar data={chartData} options={options} />;
}
